import React from "react";
import { Modal, Button, IconWarningAlt } from "@veneer/core";

interface EvaluationCanceledModalProps {
  show: boolean;
  onClose: () => void;
  t: (key: string) => string;
}

export const EvaluationCanceledModal: React.FC<
  EvaluationCanceledModalProps
> = ({ show, onClose, t }) => {
  return (
    <div style={{ position: "relative" }}>
      <Modal
        className="modalEvaluationCanceled"
        align="center"
        id="modalEvaluationCanceled"
        show={show}
        onClose={onClose}
        footer={
          <Button onClick={onClose} appearance="primary">
            {t("header.closebutton")}
          </Button>
        }
        title={t("header.evaluationCanceled")}
      >
        <IconWarningAlt size={120} />
        <br />
        <b>{t("header.evaluationCaneledMessage")}</b>
      </Modal>
    </div>
  );
};
